import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-composition-lang',
  templateUrl: './product-composition-lang.component.html',
  styleUrls: ['./product-composition-lang.component.css']
})
export class ProductCompositionLangComponent implements OnInit {
    productCompositionKeyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.productCompositionKeyno = this.stateService.getStateParams()['productcomposition_keyno'];
    }

    private async loadLanguages() {
        if (!!this.productCompositionKeyno) {
            this.inputListLanguages = await this.datatask.Post(2708, { productcomposition_keyno: this.productCompositionKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(2709, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    productcomposition_keyno: number;
    productcompositionlang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productCompositionLang', {
//        templateUrl: 'views/components/views/productCompositionLang/productCompositionLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'productCompositionLangService', function ($stateParams, stateService, productCompositionLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let productCompositionKeyno = $stateParams.productcomposition_keyno;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await productCompositionLangService.listProductCompositionLanguages({ productcomposition_keyno: productCompositionKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                productCompositionLangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
